import * as React from "react"

const TelephoneImg = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <defs>
      <clipPath id="a">
        <path
          data-name="Rectangle 48450"
          transform="translate(.5)"
          fill="#4e5a6b"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
    <g data-name="Group 96904">
      <g
        data-name="Mask Group 6285"
        transform="translate(-.5)"
        clipPath="url(#a)"
      >
        <path
          d="M15.5 4.25h-6a1.8 1.8 0 0 0-1.8 1.8v12.4a1.8 1.8 0 0 0 1.8 1.8h6a1.8 1.8 0 0 0 1.8-1.8V6.05a1.8 1.8 0 0 0-1.8-1.8Zm-3 14a.6.6 0 1 1 .6-.6.6.6 0 0 1-.6.6Z"
          fill="#78b1fe"
        />
      </g>
    </g>
  </svg>
)

export default TelephoneImg
